import { useApi } from '@proton/components';
import { querySubmitAbuseReport } from '@proton/shared/lib/api/drive/sharing';

import { getPublicTokenAndPassword } from '../../publicPage/utils/getPublicTokenAndPassword';

export function useMalwareReport() {
    const api = useApi();
    // const { getLinkPassphraseAndSessionKey } = useLink();

    const submitMalwareReport = async (params: {
        linkId: string;
        abuseCategory: string;
        reporterEmail?: string;
        reporterMessage?: string;
    }): Promise<void> => {
        const {
            // token,
            urlPassword: password,
        } = getPublicTokenAndPassword(window.location.pathname);
        // const ac = new AbortController();
        // const { passphrase } = await getLinkPassphraseAndSessionKey(ac.signal, token, params.linkId);

        return api(
            querySubmitAbuseReport({
                ShareURL: window.location.href,
                Password: password,
                AbuseCategory: params.abuseCategory,
                ReporterEmail: params.reporterEmail,
                ReporterMessage: params.reporterMessage,
                ResourcePassphrase: 'TBI', // TODO: To Be Implemented
            })
        );
    };

    return {
        submitMalwareReport,
    };
}

export const getMalwareReportComment = (fileName: string, errorMessage?: string) => {
    let comment = `File "${fileName}" is detected as potential malware.`;
    if (errorMessage) {
        comment = `${comment} Message from scanning is "${errorMessage}"`;
    }

    return comment;
};
